export * from '@ms/shared-react-people-picker/lib/PeoplePicker';
export { PeoplePicker as default } from '@ms/shared-react-people-picker/lib/PeoplePicker';